// extracted by mini-css-extract-plugin
module.exports = {"faucet-info":"OraiFaucetInfo_faucet-info__nZcEZ","address":"OraiFaucetInfo_address__2n-Fh"};